import baseAPI from '@/api';
import { GameIDType } from '@/enums/gameId';
import { GameTypeIdType } from '@/enums/gameTypeId';
import { FetchGameDifficultiesInputDto } from '@/services/dto/game-difficulties/fetch-game-difficulties-input.dto';
import { PaginatedResponse } from '@starsoft/common/models';
import { QueryFunctionContext } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { GameDifficultyProps, UseGameDifficultiesQueryKey } from './props';

export async function fetchGameDifficulties({
  queryKey,
}: QueryFunctionContext<UseGameDifficultiesQueryKey>): Promise<
  PaginatedResponse<GameDifficultyProps<GameTypeIdType>>
> {
  const { gameTypeId, limit }: FetchGameDifficultiesInputDto<GameTypeIdType> =
    queryKey[1];

  const response: AxiosResponse<
    PaginatedResponse<GameDifficultyProps<GameIDType>>
  > = await baseAPI.get<PaginatedResponse<GameDifficultyProps<GameIDType>>>(
    '/game-difficulties',
    {
      params: {
        gameTypeId,
        limit,
      },
    },
  );

  return response.data;
}
